import Pusher from 'pusher-js';

const pusherInstance = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
  cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
});

export default pusherInstance;
